import { ORG_PUBLIC_PATH_PREFIX } from '@court-sync/shared';

/** Parse org slug from a path-mode public org URL (`/club-academy/:slug/...`). */
export function parseOrgSlugFromPathname(pathname: string): string | undefined {
  const prefix = `${ORG_PUBLIC_PATH_PREFIX}/`;
  if (!pathname.startsWith(prefix)) return undefined;
  const segment = pathname.slice(prefix.length).split('/')[0];
  const slug = segment?.trim();
  return slug || undefined;
}
